import Link from 'next/link';
import { Grid } from 'ht-styleguide';

/* Types */
import { GeoList, LocationData, LocationDataCity } from '@scenes/LocationPage/locationPage.types';

/* Styles */
import styles from '../locationPage.module.scss';

/* Inline Types */
type BreadCrumbEntry = {
  displayName: string;
  url: string;
};

const defaultBreadcrumbs: Record<string, BreadCrumbEntry> = {
  home: { displayName: 'HelloTech', url: '/' },
  us: { displayName: 'United States', url: '/us' },
};

const LocationGeoList = ({ locationData, geoList }: { locationData: LocationData; geoList: GeoList }) => {
  /* Constants */
  let displayData = [] as GeoList;
  let breadcrumbs = [defaultBreadcrumbs.home, defaultBreadcrumbs.us] as BreadCrumbEntry[];

  /* Deal With GeoList */
  if (locationData?.type === 'city') {
    displayData = [];
  } else if (geoList) {
    displayData = geoList;
  }

  /* Deal With BreadCrumbs */
  if (locationData?.type === 'city') {
    breadcrumbs = [
      defaultBreadcrumbs.us,
      { displayName: (locationData as LocationDataCity).state?.displayName, url: (locationData as LocationDataCity).state?.url },
      { displayName: locationData.displayName!, url: locationData.url! },
    ];
  }

  if (locationData?.type === 'state') {
    breadcrumbs = [defaultBreadcrumbs.home, defaultBreadcrumbs.us, { displayName: locationData.displayName!, url: locationData.url! }];
  }

  return (
    <section className="paddingY-huge">
      <Grid.Fluid>
        <Grid.Row classes="paddingBottom-large paddingX-tiny1">
          {breadcrumbs.map((breadcrumb, idx, { length }) => {
            const isLast = length - 1 === idx;
            const arrow = isLast ? '' : '>';

            return (
              <span key={`${breadcrumb.url}`}>
                <h3 className="h4">
                  {isLast ? breadcrumb.displayName : <Link href={breadcrumb.url}>{breadcrumb.displayName}</Link>}
                  <span className="marginX-small">{arrow}</span>
                </h3>
              </span>
            );
          })}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column sm={4} md={8} lg={12}>
            <Grid.Row>
              {displayData.map(location => (
                <Grid.Column sm={2} md={2} lg={3} key={`${location.displayName}-${location.url}`}>
                  <p className={`p1 text-weight-medium ${styles.geoList_child}`}>
                    <Link href={location.url} prefetch={false} className={styles.geoList_anchor}>
                      {location.displayName}
                    </Link>
                  </p>
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

export default LocationGeoList;
